/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_TitleInputs */



/**
* | output |
* | --- |
* | "Sign up for Closed Caption Creator" |
*
* @param {Signup_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_title = /** @type {((inputs?: Signup_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inscrivez-vous à Closed Caption Creator")
	if (locale === "de") return /** @type {LocalizedString} */ ("Registrieren Sie sich für den Untertitel-Generator")
	if (locale === "it") return /** @type {LocalizedString} */ ("Iscriviti a Closed Caption Creator")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Зарегистрируйтесь в программе для создания субтитров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Regístrate en Closed Caption Creator")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("注册使用字幕创建器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クローズドキャプションクリエイターに登録する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लोज्ड कैप्शन क्रिएटर के लिए साइन अप करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inscreva-se no Criador de Legendas Ocultas")
	return /** @type {LocalizedString} */ ("Sign up for Closed Caption Creator")
});